<div class="multi-funds-modal">
  <header class="multi-funds-modal__header">
    <div class="multi-funds-modal__title-row">
      <h2 class="multi-funds-modal__title">{{ texts.title }}</h2>
      <ds-icon-button-v2
        emphasis="secondary-filled"
        size="s"
        icon="Close"
        [ariaLabel]="texts.closeLabel"
        (clicked)="closeModal()"
      ></ds-icon-button-v2>
    </div>

    <ds-tabs
      class="multi-funds-modal__tabs"
      size="s"
      [orientation]="tabsOrientation"
      [tabs]="tabOptions"
      [value]="activeTab"
      (valueChange)="showTab($event)"
    ></ds-tabs>
  </header>

  <div class="multi-funds-modal__body">
    <p *ngIf="activeContent.intro" class="multi-funds-modal__intro">
      {{ activeContent.intro }}
    </p>

    <div class="multi-funds-modal__section">
      <p
        class="multi-funds-modal__subtitle"
        [class.multi-funds-modal__subtitle--heading]="activeContent.funds.length > 0"
      >
        {{ activeContent.subtitle }}
      </p>

      <ul *ngIf="activeContent.bullets.length" class="multi-funds-modal__list">
        <li *ngFor="let bullet of activeContent.bullets" class="multi-funds-modal__list-item">
          <strong>{{ bullet.strong }}</strong>{{ bullet.text }}
        </li>
      </ul>
    </div>

    <div *ngIf="activeContent.funds.length" class="multi-funds-modal__funds">
      <ds-card *ngFor="let fund of activeContent.funds" shadow="l2">
        <div class="multi-funds-modal__fund">
          <div class="multi-funds-modal__fund-header">
            <span class="multi-funds-modal__fund-name">{{ fund.name }}</span>
            <ds-tag-pill
              size="s"
              [variant]="tagVariants[fund.tone ?? '']"
              [label]="fund.risk ?? ''"
            ></ds-tag-pill>
          </div>
          <p class="multi-funds-modal__fund-description">{{ fund.description }}</p>
        </div>
      </ds-card>
    </div>
  </div>
</div>
